import type { ReactNode } from 'react';

export const Between = ({ children, className = '' }: { children: ReactNode; className?: string }) => {
    return <span className={`text-size-16 line-height-16 padding-top-4 ${className}`}>{children}</span>;
};
